<template>
  <Popup v-model="showLogin" round position="bottom">
    <div class="H5LoginPopup">
      <div class="top">
        <img v-if="appointment" src="./img/time.png" alt="">
        <img v-else src="./img/info.png" alt="">

        <span v-if="topTip" style="font-weight: bold">{{ topTip }}</span>
        <span v-else style="font-weight: bold">{{ appointment ? "请填写您的手机号码，以便收到预约提醒":"请填写您的手机号码，以便为您开通权限"}}</span>
      </div>
      <div class="form">
        <Field
            class="x"
            v-model="form.phone"
            center
            label="手机号"
            clearable
            placeholder="请填写手机号"
        />
        <div style="position: relative">
          <Field
              v-model="form.code"
              center
              class="x"
              label="验证码"
              clearable
              placeholder="请输入验证码"
          >
          </Field>
          <Button :disabled="time !== 60" class="code-x" round size="small" @click="sendMsg" :class="{appointment }" type="primary">{{ time === 60 ? '发送验证码' : (time+'s') }}</Button>
        </div>
      </div>
      <Button class="submit" v-if="btnText" @click="login()"  block round type="primary">{{ btnText }}</Button>
      <Button class="submit" v-else @click="login()" :class="{appointment}" block round type="primary">{{ appointment ? "提交预约信息":  "提交"}}</Button>
      <div class="bottom">
        <img v-if="appointment" src="./img/h-aq.png" alt="">
        <img v-else src="./img/r-aq.png" alt="">
        <span style="font-weight: bold;">平台已为您开启了隐私保护</span>
      </div>
    </div>
  </Popup>
</template>

<script>
import {Popup, Field, Button, Toast} from 'vant';
import {RegPhone} from "@/utils/validate";
import {loginWxAuthorizeSendCode, loginWxAuthorizeVerifyCode} from "@/api/shareH5";
import goodStorage from "good-storage";

export default {
  name: 'H5LoginPopup',
  props: {
    btnText:{
      type:String,
      default:null
    },
    topTip:{
      type:String,
      default:null
    },
  },
  data() {
    return {
      showLogin: false,
      appointment:PAGE_PARAMS.appointment==1,
      form:{
        phone:"",
        code:""
      },
      time:60,
    }
  },
  methods:{
    Show(){
      this.showLogin = true
    },
    sendMsg(){
      if(this.time !== 60){
        return;
      }
      if(this.form.phone.length !== 11){
        Toast('请输入正确的手机号！');
        return;
      }
      loginWxAuthorizeSendCode({phone: this.form.phone}).then(r => {
         Toast('验证码已发送');
        let DJS = setInterval(_=>{
          if(this.time <=0){
            clearInterval(DJS);
            this.time = 60;
            return
          }
          this.time -- ;
        },1000)
      }).catch(e => {
        Toast(e)
      })
    },
    login() {
      const { code,phone} = this.form
      if (phone.length !== 11) {
        Toast('请输入正确手机号码');
        return
      }
      if (code === '') {
        Toast('请输入验证码');
        return
      }
      let params = {
        phone: phone,
        code: PAGE_PARAMS.code,
        registerSource: 4,
        verifyCode: code,
      };
      loginWxAuthorizeVerifyCode(params).then(r => {
        let userNurseLoginInfo = r.userNurseLoginInfo;
        goodStorage.session.set("userNurseLoginInfo", userNurseLoginInfo);
        goodStorage.set("userNurseLoginInfo", userNurseLoginInfo);
        this.$emit("loginSuccess",userNurseLoginInfo)
        this.showLogin = false
      }).catch(_ => {})
    },
  },
  components: {
    Popup,Field,Button
  },
}
</script>


<style scoped lang="scss">
.H5LoginPopup {
  width: 100%;
  padding: 18px;
  .top{
    display: flex;
    align-items: center;
    justify-content: center;
    img{
      width: 20px;
      margin-right: 8px;
    }
    span{
      font-size: 14px;
      color: #3D3D3D;
    }
  }
  .form{
    margin: 10px 0;
    .code-x{
      position: absolute;
      right: 6px;
      top: 6px;
      background: #EB5A53;
      border: none;
      width: 80px;
      color: #fff;
      &.appointment{
        background: #F3C458;
        color: #242D31;
      }
    }
    .x{
      background: #F3F3F3;
      margin-top: 20px;
      border-radius: 6px;
    }
  }
  .submit{
    margin-top: 20px;
    background: #EB5A53;
    border: none;
    color: #fff;
    &.appointment{
      background: #F3C458;
      color: #242D31;
    }
  }
  .bottom{
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 20px;
    img{
      width: 10px;
      margin-right: 8px;
    }
    span{
      font-size: 12px;
      color: #3D3D3D;
    }
  }
}
</style>
